import axios from 'axios';

const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again.';

export function getApiErrorMessage(
  error: unknown,
  fallback = DEFAULT_ERROR_MESSAGE
): string {
  if (!axios.isAxiosError(error)) {
    return fallback;
  }

  if (!error.response) {
    return 'Unable to connect to the server. Please try again.';
  }

  const detail = error.response.data?.detail;

  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }

  if (Array.isArray(detail) && typeof detail[0]?.msg === 'string') {
    return detail[0].msg;
  }

  if (error.response.status >= 500) {
    return 'Server error. Please try again later.';
  }

  return fallback;
}
